import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";

const MotorSelect = ({ name, label, options, value, onChange }) => (
  <FloatingLabel controlId={`motor-${name}`} label={`${label}*`} className="has-content">
    <Form.Select required value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">Please select</option>
      {options.map((option) => {
        const choice = typeof option === "string" ? { value: option, label: option } : option;
        return <option key={choice.value} value={choice.value}>{choice.label}</option>;
      })}
    </Form.Select>
  </FloatingLabel>
);

export default MotorSelect;
